import { csrfTokenService } from '../csrf/CsrfTokenService'
import { inject, injectable } from '~/container'
import { PuFetchInstance } from '~/utility/http'
import { SYMBOLS } from '../inversify/symbols'
import { ResendLastBookingConfirmationEmailService } from './services'

@injectable()
export class ResendLastBookingConfirmationEmailFetch
implements ResendLastBookingConfirmationEmailService
{
  @inject(SYMBOLS.PuFetchInstance)
  private puFetch: PuFetchInstance

  async requestResendBookingConfirmationEmail(email: string): Promise<void> {
    const { csrfToken } = await csrfTokenService()
    try {
      return this.puFetch.post(
        '_/fallback/about/resend_confirmation_email/',
        this.getFormData(email),
        {
          headers: {
            'X-ELDARION-AJAX': 'true',
            'X-CSRFToken': csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
          },
        },
      )
    } catch ({ response }) {
      throw new Error(response.data.errors)
    }
  }

  private getFormData(email): FormData {
    const form = new FormData()
    form.append('email', email)
    return form
  }
}
